/* eslint-disable @typescript-eslint/no-unused-vars, no-unused-vars */
import { DSFormLayoutCheckboxGroup } from '../index.js';
import type { DSFormLayoutCheckboxGroupT } from '../index.js';

// test we expose the namespace and the namespace follows our deliverable conventions
type ComponentPropsForApp = DSFormLayoutCheckboxGroupT.Props;
type ComponentPropsInternals = DSFormLayoutCheckboxGroupT.InternalProps;
type ComponentPropsDefaultProps = DSFormLayoutCheckboxGroupT.DefaultProps;
type ComponentPropsOptionalProps = DSFormLayoutCheckboxGroupT.OptionalProps;
type ComponentPropsRequiredProps = DSFormLayoutCheckboxGroupT.RequiredProps;

const testRequiredProps: ComponentPropsRequiredProps = {
  children: <div></div>,
};
const testOptionalProps: ComponentPropsOptionalProps = {};

// difference Props and InternalProps is that InternalProps has all the default props filled in
//  Props allows for partial defaults
const testPartialDefaults: Partial<ComponentPropsDefaultProps> = {};
const testProps: ComponentPropsForApp = {
  ...testRequiredProps,
  ...testOptionalProps,
  ...testPartialDefaults,
};
const testPropsAsSyntax = {
  ...testRequiredProps,
  ...testOptionalProps,
  ...testPartialDefaults,
} as ComponentPropsForApp;
// InternalProps requires all defaults to be filled in
const testCompleteDefaults: Required<ComponentPropsDefaultProps> = {
  direction: 'vertical',
  isInsideLayoutBlock: false,
};
const testInternalProps: ComponentPropsInternals = {
  ...testRequiredProps,
  ...testOptionalProps,
  ...testCompleteDefaults,
};
const testInternalPropsAsSyntax = {
  ...testRequiredProps,
  ...testOptionalProps,
  ...testCompleteDefaults,
} as ComponentPropsInternals;

// using the explicit type definition, if there is an error, it will be marked on the key that is wrong
const testExplicitDefinition: ComponentPropsForApp = {
  direction: 'horizontal',
  id: 'id-1',
  children: <div></div>,
};

// using the "as" syntax, if there is an error, it will be marking the whole object as wrong because it is not compatible with the type
const testInferedTypeCompatibility = {
  direction: 'horizontal',
  id: 'id-1',
  children: <div></div>,
} as ComponentPropsForApp;

const testDefinitionAsConst = {
  direction: 'horizontal',
  id: 'id-1',
  children: <div></div>,
} as const;

const ExampleUsageComponent = () => (
  <>
    {/* works with explicitly casted props, all syntaxes */}
    <DSFormLayoutCheckboxGroup {...testExplicitDefinition} />
    <DSFormLayoutCheckboxGroup {...testInferedTypeCompatibility} />
    <DSFormLayoutCheckboxGroup {...testDefinitionAsConst} />
    {/* works with inline values */}
    <DSFormLayoutCheckboxGroup direction="vertical">
      <div></div>
      <div></div>
    </DSFormLayoutCheckboxGroup>
  </>
);
